import React from "react";
import Marquee from "react-fast-marquee";
import { Flame } from "lucide-react";

const ITEMS = [
  "รสชาติคนไทย 100%",
  "Expert in Thai style noodle",
  "Hand-pulled noodles",
  "Wok-fired daily",
  "From £12.99",
  "Bangkok · Manchester",
  "Open until 23:00 Fri–Sat",
];

export default function MarqueeBar() {
  return (
    <div
      data-testid="marquee-bar"
      className="bg-[#1A1A1A] text-white py-5 border-y border-[#1A1A1A]"
    >
      <Marquee gradient={false} speed={42} className="marquee-fade">
        {ITEMS.concat(ITEMS).map((item, i) => (
          <div key={i} className="flex items-center gap-6 px-8">
            <span className="font-display text-2xl md:text-3xl font-semibold tracking-tight">
              {item}
            </span>
            <Flame className="h-5 w-5 text-[#F5A623]" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
